// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Xhln","info":"PatientInfo_info__gr52r"};